import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errorText } from "@/lib/api";
import { usePlayer } from "@/lib/player";

export default function LoginDialog() {
  const { loginOpen, closeLogin, login } = usePlayer();
  const navigate = useNavigate();
  const [form, setForm] = useState({ login: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(form.login.trim(), form.password);
      setForm({ login: "", password: "" });
      closeLogin();
      navigate("/panel");
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={loginOpen} onOpenChange={(o) => !o && closeLogin()}>
      <DialogContent className="max-w-sm bg-[#0a0c1e] border-[#2c2f52] text-slate-200" data-testid="login-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-slate-100">Zaloguj się</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-400 -mt-2">Użyj loginu i hasła konta z gry.</p>
        <form onSubmit={submit} className="space-y-3" data-testid="login-form">
          <input className="steel-input !mt-0" placeholder="Login konta" autoComplete="username" autoFocus value={form.login}
            onChange={(e) => setForm({ ...form, login: e.target.value })} data-testid="login-input" />
          <input className="steel-input !mt-0" type="password" placeholder="Hasło" autoComplete="current-password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
          {error && <p className="text-sm text-red-300" data-testid="login-error">{error}</p>}
          <button disabled={busy || !form.login || !form.password} className="btn btn-primary w-full" data-testid="login-submit-btn">
            {busy ? "Logowanie..." : "Zaloguj"}
          </button>
        </form>
        <p className="text-xs text-slate-400">
          Nie masz konta?{" "}
          <Link to="/rejestracja" onClick={closeLogin} className="text-[#9fb2ff] hover:underline" data-testid="login-register-link">Załóż konto</Link>
        </p>
      </DialogContent>
    </Dialog>
  );
}
